













import Vue from 'vue';
import ChartWidget from '@/components/dashboard/ChartWidget.vue';
import { mapGetters } from 'vuex';
import i18n from '@/i18n';

export default Vue.extend({
  name: 'DashboardChart',
  components: { ChartWidget },

  computed: {
    ...mapGetters({
      getChart: 'dashboard/getChart',
    }),
    chartLoader(): boolean {
      return this.$store.getters['dashboard/getLoader']('chart');
    },
    refs(): any {
      return this.$refs;
    },
    chartPeriods(): Array<string> {
      return this.getChart?.data?.map((item) => item.period.split(' ')[0]);
    },
    chartData(): Array<any> {
      const campaigns = {};
      const data = [] as Array<any>;

      if (this.getChart?.data?.length) {
        for (const item of this.getChart?.data) {
          for (const campaign of item.campaigns) {
            if (!campaign.name) continue;

            if (campaigns[campaign.name]) {
              campaigns[campaign.name].data.push(campaign[this.currentField]);
            } else {
              campaigns[campaign.name] = {
                name: campaign.name,
                data: [campaign[this.currentField]],
              };
            }
          }
        }

        for (const key in campaigns) {
          if (campaigns[key]) {
            data.push(campaigns[key]);
          }
        }
      }

      return data;
    },
  },

  methods: {
    loadChart() {
      this.$store
        .dispatch('dashboard/loadChart', this.currentField)
    },
    changeSelect(field) {
      this.currentField = field;
      this.loadChart();
    },
  },

  data() {
    return {
      currentField: 'sum_revenue',
      selectOptions: [
        {
          label: i18n.t('pages.dashboard.spend'),
          value: 'sum_revenue',
        },
        {
          label: i18n.t('pages.dashboard.impressions'),
          value: 'count_view',
        },
        {
          label: i18n.t('pages.dashboard.clicks'),
          value: 'count_click',
        },
        {
          label: i18n.t('pages.dashboard.cpc'),
          value: 'cpc',
        },
        {
          label: i18n.t('pages.dashboard.ctr'),
          value: 'ctr',
        },
      ],
    };
  },
});
